import { SortBy } from '../sort/sort.js';
import { buildPaginatedCommerceAPIRequest, } from './paginated-commerce-api-request-builder.js';
export const buildFilterableCommerceAPIRequest = (state, navigatorContext) => {
    return {
        ...buildPaginatedCommerceAPIRequest(state, navigatorContext),
        facets: [...getFacets(state)],
        ...(state.commerceSort && {
            sort: getSort(state.commerceSort.appliedSort),
        }),
    };
};
function getFacets(state) {
    if (!state.facetOrder || !state.commerceFacetSet) {
        return [];
    }
    return state.facetOrder
        .filter((facetId) => state.commerceFacetSet?.[facetId])
        .map((facetId) => {
        return state.manualNumericFacetSet?.[facetId]?.manualRange
            ? {
                facetId,
                field: facetId,
                numberOfValues: 1,
                isFieldExpanded: false,
                preventAutoSelect: true,
                type: 'numericalRange',
                values: [state.manualNumericFacetSet[facetId].manualRange],
                initialNumberOfValues: 1,
            }
            : state.commerceFacetSet[facetId].request;
    })
        .filter((facet) => facet && facet.values.length > 0);
}
function getSort(appliedSort) {
    if (appliedSort.by === SortBy.Relevance) {
        return {
            sortCriteria: SortBy.Relevance,
        };
    }
    else {
        return {
            sortCriteria: SortBy.Fields,
            fields: appliedSort.fields.map(({ name, direction }) => ({
                field: name,
                direction,
            })),
        };
    }
}
